import { useContent } from "@/context/ContentContext";
import { Zap } from "lucide-react";

export default function ExtraInternetTable() {
  const { internet_codes, pages } = useContent();
  const p = pages?.extra_internet || {};
  return (
    <section data-testid="extra-internet-section" className="section-pad">
      <div className="max-w-5xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">{p.eyebrow || "Dodatkowe paczki internetu"}</div>
          <h2 data-testid="extra-title" className="font-display text-3xl sm:text-4xl font-black text-white mt-3">
            {p.title || "Skończył Ci się internet? Doładuj kodem."}
          </h2>
          <p className="text-white/70 mt-3">
            {p.subtitle || "Wybierz paczkę i wpisz kod na telefonie. Doładowanie działa natychmiast."}
          </p>
        </div>

        <div className="rm-card mt-8 overflow-hidden">
          {/* Widok tabelaryczny – desktop */}
          <table className="w-full hidden md:table" data-testid="extra-internet-table">
            <thead className="bg-slate-100 text-slate-600 uppercase text-xs">
              <tr>
                <th className="text-left p-4">{p.col_code || "Kod"}</th>
                <th className="text-left p-4">{p.col_size || "Wielkość paczki"}</th>
                <th className="text-right p-4">{p.col_price || "Cena"}</th>
              </tr>
            </thead>
            <tbody>
              {internet_codes.map((row) => (
                <tr key={row.code} className="border-t border-slate-100 hover:bg-slate-50/60 transition">
                  <td className="p-4">
                    <code className="font-mono text-[#1f3a8a] bg-[#1f3a8a]/10 px-3 py-1.5 rounded-md font-bold text-sm">
                      {row.code}
                    </code>
                    <span className="text-slate-500 text-xs ml-3">słuchawka</span>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center gap-2 text-slate-800 font-semibold">
                      <Zap size={16} className="text-[#ef4444]" />
                      {row.size}
                    </div>
                  </td>
                  <td className="p-4 text-right">
                    <span className="font-display text-2xl font-black text-[#1f3a8a]">{row.price}</span>
                    <span className="text-slate-500 ml-1">zł</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Widok kartowy – mobile */}
          <div className="md:hidden divide-y divide-slate-100" data-testid="extra-internet-cards">
            {internet_codes.map((row) => (
              <div key={row.code} className="p-4 flex items-center justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <code className="font-mono text-[#1f3a8a] bg-[#1f3a8a]/10 px-2.5 py-1 rounded-md font-bold text-sm break-all inline-block">
                    {row.code}
                  </code>
                  <div className="flex items-center gap-1.5 text-slate-800 font-semibold text-sm mt-2">
                    <Zap size={14} className="text-[#ef4444]" />
                    {row.size}
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <span className="font-display text-2xl font-black text-[#1f3a8a]">{row.price}</span>
                  <span className="text-slate-500 ml-1 text-sm">zł</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="text-white/60 text-xs mt-4">
          {p.note_bottom || "Wpisz kod z klawiatury telefonu i naciśnij słuchawkę / przycisk połączenia. Środki zostaną pobrane z konta."}
        </p>
      </div>
    </section>
  );
}
